module.exports = __webpack_public_path__ + "static/media/app-bar-save.b1d370c7.svg";